module.exports = __webpack_public_path__ + "52637f88ecd8745096898f253c342df3.pdf";